import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastProvider } from './components/ui/Toast';
import { PantheonProvider } from './providers/PantheonProvider';
import { useAuth } from './hooks/useAuth';
import { Layout } from './pages/Layout';
import { LoginPage } from './pages/LoginPage';
import { AuthCallbackPage } from './pages/AuthCallbackPage';
import { DashboardPage } from './pages/DashboardPage';
import { HermesPage } from './pages/HermesPage';
import { ProjectsPage } from './pages/ProjectsPage';
import { SettingsPage } from './pages/SettingsPage';
import { DaedalusPage } from './pages/DaedalusPage';
import { PrometheusPage } from './pages/PrometheusPage';
import { AthenaPage } from './pages/AthenaPage';
import { ArgusPage } from './pages/ArgusPage';
import { RunnersPage } from './pages/RunnersPage';
import { CostsPage } from './pages/CostsPage';
import { AnalyticsPage } from './pages/AnalyticsPage';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001/v1';
const WS_URL = import.meta.env.VITE_WS_URL || 'ws://localhost:3002';

function AuthenticatedApp() {
  const { token, user, loading, isAuthenticated, login, logout } = useAuth({
    apiUrl: API_URL,
  });

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        Loading...
      </div>
    );
  }

  if (!isAuthenticated || !token) {
    return (
      <Routes>
        <Route path="/auth/callback" element={<AuthCallbackPage apiUrl={API_URL} />} />
        <Route path="*" element={<LoginPage onLogin={login} />} />
      </Routes>
    );
  }

  return (
    <PantheonProvider config={{ apiUrl: API_URL, wsUrl: WS_URL, authToken: token }}>
      <Routes>
        <Route path="/" element={<Layout user={user} onLogout={logout} />}>
          <Route index element={<DashboardPage />} />
          <Route path="analytics" element={<AnalyticsPage />} />
          <Route path="athena" element={<AthenaPage />} />
          <Route path="athena/:initiativeId" element={<AthenaPage />} />
          <Route path="hermes" element={<HermesPage />} />
          <Route path="hermes/:sessionId" element={<HermesPage />} />
          <Route path="daedalus" element={<DaedalusPage />} />
          <Route path="daedalus/:sessionId" element={<DaedalusPage />} />
          <Route path="argus" element={<ArgusPage />} />
          <Route path="argus/:initiativeId" element={<ArgusPage />} />
          <Route path="runners" element={<RunnersPage />} />
          <Route path="prometheus" element={<PrometheusPage />} />
          <Route path="prometheus/:sessionId" element={<PrometheusPage />} />
          <Route path="projects" element={<ProjectsPage />} />
          <Route path="costs" element={<CostsPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="auth/callback" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </PantheonProvider>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
        <AuthenticatedApp />
      </ToastProvider>
    </BrowserRouter>
  );
}
